"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordRelayMessageUpdateMessageToJSON = exports.DiscordRelayMessageUpdateMessageFromJSONTyped = exports.DiscordRelayMessageUpdateMessageFromJSON = void 0;
function DiscordRelayMessageUpdateMessageFromJSON(json) {
    return DiscordRelayMessageUpdateMessageFromJSONTyped(json, false);
}
exports.DiscordRelayMessageUpdateMessageFromJSON = DiscordRelayMessageUpdateMessageFromJSON;
function DiscordRelayMessageUpdateMessageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'channelId': json['channelId'],
        'guildId': json['guildId'],
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'editedTimestamp': (new Date(json['editedTimestamp'])),
        'author': json['author'],
    };
}
exports.DiscordRelayMessageUpdateMessageFromJSONTyped = DiscordRelayMessageUpdateMessageFromJSONTyped;
function DiscordRelayMessageUpdateMessageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': (value.timestamp.toISOString()),
        'editedTimestamp': (value.editedTimestamp.toISOString()),
        'author': value.author,
    };
}
exports.DiscordRelayMessageUpdateMessageToJSON = DiscordRelayMessageUpdateMessageToJSON;
